package org.gymly.api

class ApiException(val status: Int, message: String) : Exception(message)
